var exports = {
  "apps-list": "xe30f6088--989f82--apps-list",
  "apple-btn": "xe30f6088--989f82--apple-btn",
  "google-btn": "xe30f6088--989f82--google-btn",
  "ru-store-btn": "xe30f6088--989f82--ru-store-btn",
  "app-gallery-btn": "xe30f6088--989f82--app-gallery-btn",
};

module.exports = exports;
